module.exports = __webpack_public_path__ + "img/icon_genjin.1db92b0f.png";